import { Fragment } from "react";
import { Card, CardBody, Col } from "reactstrap";
import DividerBody from "./DividerBody";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { DividerDropdownTitle } from "../../../../Constants/Constants";
import { DividerCommonData, DividerDropdownSubTitle } from "../../../../Data/UiKits/Dropdown";

const DividerDropdown = () => {
  return (
    <Col md="6">
      <Card className="height-equal">
        <CommonCardHeader title={DividerDropdownTitle} span={DividerDropdownSubTitle} />
        <CardBody className="rtl-dropdown">
          <div className="common-flex">
            {DividerCommonData &&
              DividerCommonData.map((item, index) => (
                <Fragment key={index}>
                  <DividerBody item={item} />
                </Fragment>
              ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default DividerDropdown;
